module.exports = __webpack_public_path__ + "static/media/AnglesPositioning.3eb0de7b.jpg";